module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("vue 全局公用函数")]), _vm._v(" "), _c('p', [_vm._v("如果你需要让一个工具函数在每个组件可用，可以把方法挂载到 "), _c('code', [_vm._v("Vue.prototype")]), _vm._v("上。")]), _vm._v(" "), _c('h2', [_vm._v("注册")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("main.js")]), _vm._v(" 中")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("Vue.prototype.$method = "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }), _vm._v(") ")]), _vm._v("{}\n")])]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("一般建议函数名使用 "), _c('code', [_vm._v("$")]), _vm._v(" 前缀。像 "), _c('code', [_vm._v("vue-router")]), _vm._v(" 的 "), _c('code', [_vm._v("$route")]), _vm._v(" 和 "), _c('code', [_vm._v("$router")]), _vm._v("。")])]), _vm._v(" "), _c('h2', [_vm._v("使用")]), _vm._v(" "), _c('p', [_vm._v("那么组件代码里")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  created () {\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$method()\n  }\n}\n")])]), _vm._v(" "), _c('h2', [_vm._v("说明")]), _vm._v(" "), _c('p', [_vm._v("挂载到 "), _c('code', [_vm._v("prototype")]), _vm._v(" 上是为了方便组件内直接用 "), _c('code', [_vm._v("this.$method")]), _vm._v(" 来使用，你也可以直接用 "), _c('code', [_vm._v("Vue.method")]), _vm._v("，这样同样可以全局使用，不过在组件内就需要再 import 一次 "), _c('code', [_vm._v("Vue")]), _vm._v(" 了。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-219425b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-219425b2"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vue-global-method-157.vue
// module id = 2086
// module chunks = 219